<template lang="pug">
  .row.middle.space-between
    button.m-right-1(@click='toggleFilters')
      simple-svg.m4-top-2.dark-gray-icon(:filepath='filtersIcon' width='25px' height='25px')
    transition(name='slide')
      .filters.item-1.row.middle(v-if='showFilters')
        text-input.item-3.m-right-1(
          name='email'
          :placeholder='$t("team.searchbar.emailPlaceholder")'
          :value='name'
          :updateMethod='updateName'
          @submit='submit'
        )
        k-select.m4-top-2.item-2.m-right-1(
          withBorder
          name='role'
          keyName='value'
          labelName='label'
          :emptyOption='$t("team.searchbar.roles.none")'
          @selectOption='updateSelect'
          :preselectedOption='role'
          :options='roles'
        )
        k-select.m4-top-2.item-2.m-right-1(
          withBorder
          name='level'
          keyName='id'
          labelName='label'
          @selectOption='updateSelect'
          :preselectedOption='level'
          :emptyOption='$t("team.searchbar.levels.none")'
          :options='educationalLevelsOptions'
        )
        k-select.m4-top-2.item-2.m-right-1(
          v-if='!isTeacher'
          withBorder
          name='status'
          keyName='value'
          labelName='label'
          :emptyOption='$t("team.searchbar.status.none")'
          @selectOption='updateSelect'
          :preselectedOption='status'
          :options='statusOptions'
        )
        button.m4-top-2.secondary-button(@click='submit')
          | {{ !hasFiltered ? $t('team.searchbar.search') : $t('team.searchbar.cleanSearch') }}
    button.m-left-2.m4-top-2.primary-button.invite-button.with-icon(v-if='!isTeacher' @click='showUsersModal')
      simple-svg.m-right-1.white-icon(
        :filepath='mailIcon'
        width='20px'
        height='20px'
      )
      | {{ $t('team.searchbar.inviteNewMembers') }}
</template>

<script>
import KSelect from '@/components/KSelect'
import TextInput from '@/components/Inputs/TextInput'
import mailIcon from '@/assets/ic_mail.svg'
import { rolesIds, rolesOptions, teamStatusOptions, userPrimaryRoles } from '../../utils/constants'
import { i18n } from '../../main'
import { mapActions, mapState } from 'vuex'
import { toLowerCamelCase } from '../../utils/string'
import userRole from '../../mixins/userRole'
import filtersIcon from '@/assets/ic_filters.svg'

export default {
  mixins: [userRole],
  components: { TextInput, KSelect },
  data() {
    return {
      filtersIcon,
      mailIcon,
      showFilters: false,
      hasFiltered: false,
      name: '',
      level: null,
      role: null,
      status: null,
      orderAsc: false
    }
  },
  computed: {
    ...mapState({
      educationalLevels: state => state.profile.educationalLevels
    }),
    roles() {
      return rolesOptions.map(role => ({ ...role, label: i18n.t(`team.searchbar.roles.${role.label}`) }))
    },
    educationalLevelsOptions() {
      return this.educationalLevels.map(level => ({ id: level.id, label: i18n.t(`team.searchbar.levels.${toLowerCamelCase(level.name)}`) }))
    },
    statusOptions() {
      return teamStatusOptions.map(option => ({ ...option, label: i18n.t(`team.searchbar.status.${option.label}`) }))
    }
  },
  async created() {
    await this.hydrateEducationalLevels()
  },
  methods: {
    ...mapActions([
      'hydrateEducationalLevels',
      'showElement'
    ]),
    toggleFilters() {
      this.showFilters = !this.showFilters
    },
    updateSelect(field, value) {
      this[field] = value
    },
    updateName(newValue) {
      this.name = newValue
    },
    showUsersModal() {
      this.showElement({ element: 'inviteUsersModal' })
    },
    submit() {
      if (this.hasFiltered) {
        this.name = ''
        this.level = null
        this.role = null
        this.status = null
        this.hasFiltered = false
        this.$emit('resetFilters')
        return
      }
      this.$emit('submitSearch', {
        search: this.name,
        role: Object.keys(userPrimaryRoles).find(key => rolesIds[key.toLowerCase()] === this.role) || '',
        invitationStatus: this.status,
        educationalLevel: this.level,
        orderAsc: this.orderAsc
      })
      this.hasFiltered = true
    }
  }
}
</script>

<style lang="scss" scoped>
.invite-button{
  --max-width: none;
}

.slide-enter-active {
  transition: all .3s ease;
}
.slide-leave-active {
  transition: all .5s ease;
}
.slide-enter, .slide-leave-to {
  transform: translateX(-10px);
  opacity: 0;
}
</style>
